import { render, staticRenderFns } from "./zlkflink.vue?vue&type=template&id=52bf2c7e"
import script from "./zlkflink.vue?vue&type=script&lang=js"
export * from "./zlkflink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports